import { render, staticRenderFns } from "./PromotionPoint.vue?vue&type=template&id=84b7d01a&scoped=true&"
import script from "./PromotionPoint.vue?vue&type=script&lang=js&"
export * from "./PromotionPoint.vue?vue&type=script&lang=js&"
import style0 from "./PromotionPoint.vue?vue&type=style&index=0&id=84b7d01a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b7d01a",
  null
  
)

export default component.exports